/**
 * Quem enxerga a área de Vendas.
 *
 * Vendas nasceu como pedido do squad MG, e o admin também enxerga — como no
 * resto do sistema. O escopo real dos dados é feito no backend por
 * `Cotacao.squadId` (cada squad vê o que é seu; admin vê tudo), então liberar
 * outro squad aqui é só acrescentar o nome nesta lista.
 */
export const SQUADS_COM_VENDAS = ['MG'];

export function podeAcessarVendas(squadNome: string | null | undefined, isAdmin: boolean): boolean {
  if (isAdmin) return true;
  if (!squadNome) return false;
  return SQUADS_COM_VENDAS.some((s) => s.toLowerCase() === squadNome.toLowerCase());
}
